(() => {
  function dimensions(text) {
    const parts = String(text).replace(/[×]/g, 'x').split(/\s*x\s*/i);
    if (parts.length !== 2) return null;
    const inches = part => {
      const m = part.trim().match(/^(\d+(?:\.\d+)?)(?:\s*['’′]\s*(\d+(?:\.\d+)?)?\s*["”″]?)?$/);
      return m ? Math.round(Number(m[1]) * 12 + Number(m[2] || 0)) : NaN;
    };
    const result = parts.map(inches);
    return result.every(n => Number.isFinite(n) && n > 0 && n <= 1200) ? result : null;
  }
  window.MilagroStockPadDimensions = dimensions;
  function readVariants(text) {
    const value = JSON.parse(text);
    if (Array.isArray(value)) return value;
    const columns = value.variant_columns;
    return columns.id.map((id, index) => ({
      id, title: columns.title[index], price: columns.price[index],
      available: columns.available[index], barcode: columns.barcode[index],
    }));
  }
  if (customElements.get('stock-rug-pad')) return;
  customElements.define('stock-rug-pad', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.form);
      if (!this.form || this.bound) return;
      this.bound = true;
      this.variants = readVariants(this.querySelector('[data-rug-variants]').textContent);
      this.pads = readVariants(this.querySelector('[data-pad-variants]').textContent);
      this.checkbox = this.querySelector('input[type=checkbox]');
      this.error = this.querySelector('[role=alert]');
      this.change = () => this.refresh();
      this.submit = e => this.add(e);
      this.form.addEventListener('submit', this.submit, true);
      this.scope = this.closest('[id^="MainProduct-"]') || this.parentElement;
      this.scope.addEventListener('change', this.change);
      this.observer = new MutationObserver(this.change);
      this.observer.observe(this.form, {subtree:true, attributes:true, attributeFilter:['value']});
      this.refresh();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.submit, true);
      this.scope?.removeEventListener('change', this.change);
      this.observer?.disconnect();
      this.bound = false;
    }
    refresh() {
      const id = this.form.querySelector('[name=id]')?.value;
      this.variant = this.variants.find(v => String(v.id) === id);
      this.size = dimensions(this.variant?.title);
      if (!this.size && this.variants.length === 1) {
        const match = this.dataset.title.match(/(\d+(?:\.\d+)?(?:\s*['’′]\s*\d*\s*["”″]?)?\s*[x×]\s*\d+(?:\.\d+)?(?:\s*['’′]\s*\d*\s*["”″]?)?)/i);
        this.size = match && dimensions(match[1]);
      }
      this.hidden = !this.size || !this.variant?.available;
      if (this.hidden) { this.checkbox.checked = false; return; }
      this.cents = Math.round(this.size[0] * this.size[1] / 144 * Number(this.dataset.rate));
      this.label = this.size.map(n => `${Math.floor(n / 12)}′ ${n % 12}″`).join(' x ');
      this.querySelector('[data-pad-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency}).format(Math.round(this.cents * (1 - Number(this.dataset.discount || 0) / 100)) / 100);
      this.querySelector('[data-pad-size]').textContent = this.label;
    }
    async add(event) {
      if (!this.checkbox.checked || this.hidden) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      this.refresh();
      if (this.hidden) return;
      this.busy = true;
      const size = [...this.size];
      const cents = this.cents;
      const label = this.label;
      const selectedForm = new FormData(this.form);
      this.error.textContent = '';
      const button = this.form.querySelector('[name=add]');
      button?.classList.add('btn--loading');
      button?.setAttribute('aria-disabled','true');
      try {
        const sizeKey = size.join(':');
        const found = this.pads.find(v => dimensions(v.title)?.join(':') === sizeKey && v.available && Number(v.price) === cents);
        let padId = found?.id;
        if (!padId) {
          const response = await fetch('https://mto.milagrocollective.com/api/create-rug-variants', {
            method:'POST', signal:AbortSignal.timeout(15000), headers:{'Content-Type':'application/json'},
            body:JSON.stringify({payload:{shop_name:window.Shopify.shop,main_product:{id:Number(this.dataset.pad),variant:{price:(cents/100).toFixed(2),barcode:`STOCKPAD-${sizeKey}`,optionValues:[{optionName:this.dataset.option,name:label}]}}}})
          });
          const data = await response.json();
          if (!response.ok || data.error) throw new Error('The rug pad could not be prepared. Please try again.');
          padId = String(data.MainVariant?.productVariants?.[0]?.id || '').split('/').pop();
          if (!/^\d+$/.test(padId)) throw new Error('The rug pad could not be prepared. Please try again.');
        }
        // A pad size the API has just created takes a while to reach the
        // storefront; until then ?variant= falls back to the first variant.
        // Back off across roughly half a minute rather than two seconds.
        const delays = [500, 1000, 1500, 2000, 3000, 4000, 5000, 6000, 7000];
        let verified = false;
        let lastSeen = null;
        for (let attempt = 0; attempt <= delays.length; attempt++) {
          try {
            const check = await fetch(`${window.Shopify?.routes?.root || '/'}products/${this.dataset.padHandle}?variant=${encodeURIComponent(padId)}&section_id=mto-variant-check&ts=${Date.now()}`, {cache:'no-store',signal:AbortSignal.timeout(5000)});
            if (check.ok) {
              const doc = new DOMParser().parseFromString(await check.text(), 'text/html');
              const variant = JSON.parse(doc.querySelector('[data-mto-variant-check]')?.textContent || 'null');
              lastSeen = variant && {id:variant.id, title:variant.title, price:variant.price, available:variant.available};
              if (variant && String(variant.id) === String(padId) && variant.available && Number(variant.price) === cents && dimensions(variant.title)?.join(':') === sizeKey) {
                verified = true;
                break;
              }
            } else {
              lastSeen = {status:check.status};
            }
          } catch (checkError) {
            lastSeen = {error:checkError.name};
          }
          if (attempt < delays.length) await new Promise(resolve => setTimeout(resolve, delays[attempt]));
        }
        if (!verified) {
          const verifyError = new Error('We could not confirm your rug pad size and price. Nothing was added. Please try again.');
          verifyError.detail = {padId, sizeKey, cents, lastSeen};
          throw verifyError;
        }
        const form = selectedForm;
        const quantity = Number(form.get('quantity') || 1);
        const properties = {};
        for (const [key,value] of form) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = value;
        }
        const rug = {id:form.get('id'),quantity,properties};
        if (form.get('selling_plan')) rug.selling_plan = form.get('selling_plan');
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method:'POST',signal:AbortSignal.timeout(20000),headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[rug,{id:padId,quantity,properties:{'For rug':this.dataset.title,'Rug size':label}}]})
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || 'Unable to add these items. Please try again.');
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (error) {
        try {
          window.Sentry?.captureException(error, {
            tags: {mto_step: 'stock-rug-pad'},
            extra: {rug: this.dataset.title, padHandle: this.dataset.padHandle, size: label, cents, detail: error.detail || null},
          });
        } catch (reportingError) { /* never block the shopper on reporting */ }
        this.error.textContent = error.name === 'TimeoutError' ? 'This is taking longer than expected. Check your cart before trying again.' : error.message;
      } finally {
        this.busy = false;
        button?.classList.remove('btn--loading');
        button?.removeAttribute('aria-disabled');
      }
    }
  });
})();

